import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=2470da9c&scoped=true"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"
import style0 from "./nav.vue?vue&type=style&index=0&id=2470da9c&prod&lang=less"
import style1 from "./nav.vue?vue&type=style&index=1&id=2470da9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2470da9c",
  null
  
)

export default component.exports